import { render, staticRenderFns } from "./StudyEdit.vue?vue&type=template&id=a7a4b6e8&"
import script from "./StudyEdit.vue?vue&type=script&lang=js&"
export * from "./StudyEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports